import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Game from './Game';
import GameObject from './GameObject/GameObject';
import { sentryInit } from './Sentry';
import Environment from './Utility/Environment';
import { GameCheats } from './Cheats';
import CheatsManager from "CheatsManager";
import { getGameConfig } from '@platform/GameConfig';
import './Utility/PixiExtends';

declare global {
    interface Window {
        game: typeof Game;
        GameObject: typeof GameObject;
        sgPlatform: string;
    }
}

function sentryInitAfterGameConfig() {
    if (process?.env.NODE_ENV === Environment.PRODUCTION) {
        sentryInit();
    }
}

new CheatsManager({
    autoEnableCheats: process?.env.NODE_ENV === Environment.DEVELOPMENT,
    enableCheatsFunc: () => {
        (window as any).cheats = GameCheats;
        window.game = Game;
    },
});

//@ts-ignore
window.onWrapperReady = () => {

    const freezeGame = ()=> {
        Howler.volume(0);
        //@ts-ignore
        window.isSoundFrozen = true;
    }

    const unfreezeGame = () => {
        Howler.volume(1);
        //@ts-ignore
        window.isSoundFrozen = false;
    }

     //@ts-ignore
     FBInstant.setPauseHandler(()=> {
        freezeGame();
    });

    //@ts-ignore
    FBInstant.setUnpauseHandler(()=> {
        unfreezeGame();
    });
    
    getGameConfig().then(config => {
        PIXI.utils.skipHello();
        return Game.init(config);
    });
}

